import React from "react";
import { useTranslation } from "react-i18next";

const CapabilitySection = () => {
  const { t } = useTranslation();
  return (
    <section className="bg-green-800 text-white py-16 md:py-20">
      {/* Heading */}
      <div className="text-center mb-10">
        <h2 className="font-arya text-2xl font-medium">{t("capabilitySection.heading")}</h2>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 text-center gap-10 px-6 max-w-4xl mx-auto">
        <div className="flex flex-col gap-2">
          <h3 className="text-3xl font-bold">{t("capabilitySection.stats.stat1.value")}</h3>
          <p className="text-sm opacity-90 text-[#CFCFCF]">
            {" "}
            {t("capabilitySection.stats.stat1.description")}
          </p>
        </div>
        <div className="flex flex-col gap-2">
          <h3 className="text-3xl font-bold">100%</h3>
          <p className="text-sm opacity-90 text-[#CFCFCF]">
            {t("capabilitySection.stats.stat2.description")}
          </p>
        </div>
        <div className="flex flex-col gap-2">
          <h3 className="text-3xl font-bold">Smart</h3>
          <p className="text-sm opacity-90 text-[#CFCFCF]">
            {t("capabilitySection.stats.stat3.description")}
          </p>
        </div>
      </div>
    </section>
  );
};

export default CapabilitySection;
